import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { NetworkLoggerFacade } from 'store/network-logger-store/network-logger.facade';
import { NetworkLogEntry } from 'store/network-logger-store/network-logger.reducer';

@Injectable()
export class NetworkLoggerInterceptor implements HttpInterceptor {
  constructor(private networkLoggerFacade: NetworkLoggerFacade) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let logEntry: NetworkLogEntry = {
      id: Date.now().toString() + Math.random().toString(36).substring(2),
      url: req.urlWithParams,
      method: req.method,
      requestSize: req.body ? JSON.stringify(req.body).length : 0,
      requestTimestamp: Date.now(),
    };

    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          const responseSize = event?.body?.size // for blob responses
            ? event?.body?.size
            : event.body
            ? JSON.stringify(event.body).length
            : 0;

          logEntry = {
            ...logEntry,
            statusCode: event.status,
            responseSize,
            responseTimestamp: Date.now(),
          };

          this.networkLoggerFacade.logNetworkActivity(logEntry);
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        this.networkLoggerFacade.logNetworkActivity(logEntry);
        return throwError(() => error);
      })
    );
  }
}
